/***
*
*   uploadFailureMessage
*   The text a public form shows when a file upload fails.
*
*   The upload route answers 400 with a readable { message } for each
*   deliberate refusal (a closed form, a bad key part, a file that is too
*   large). Any other failure gets a fixed text: a 500 can carry raw server
*   error text, and a 429 answer is a plain string.
*
*   Pure, like media-url.js, so it is testable without mounting a view.
*
**********/

export const UPLOAD_FAILED_TEXT = "File upload failed. Please try again.";

export function uploadFailureMessage(err) {
  const message = err?.response?.status === 400 && err.response.data?.message;
  return typeof message === "string" && message !== "" ? message : UPLOAD_FAILED_TEXT;
}
